var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"939e31b9ee1ff49f7460f913ce39b4466b8e55cc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["homeroom-frontend-prod@joinhomeroom"]={id:"939e31b9ee1ff49f7460f913ce39b4466b8e55cc"};
      